import { useCallback } from "react";

import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import HeightIcon from "@mui/icons-material/Height";
import ToggleButton from "@mui/material/ToggleButton";
import type { ToggleButtonGroupProps } from "@mui/material/ToggleButtonGroup";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { useTranslation } from "react-i18next";

import { MetricRangeType } from "@waterly/graphql-types";

export type MetricRangeTypeSelectProps = {
  metricRangeType: MetricRangeType | null;
  onChange: (metricRangeType: MetricRangeType | null) => void;
  fullWidth?: boolean;
};

const MetricRangeTypeSelect = ({ metricRangeType, onChange, fullWidth }: MetricRangeTypeSelectProps) => {
  const { t } = useTranslation(["common"]);

  const handleChange = useCallback<Required<ToggleButtonGroupProps>["onChange"]>(
    (_event, newMetricRangeType: MetricRangeType | null) => {
      onChange(newMetricRangeType);
    },
    [onChange],
  );

  return (
    <ToggleButtonGroup
      color="primary"
      value={metricRangeType}
      exclusive
      onChange={handleChange}
      fullWidth={fullWidth}
    >
      <ToggleButton value={MetricRangeType.Lower}>
        <ArrowDownwardIcon />
        {t("common:lower_limits_only")}
      </ToggleButton>
      <ToggleButton value={MetricRangeType.Both}>
        <HeightIcon /> {t("common:both_lower_and_upper")}
      </ToggleButton>
      <ToggleButton value={MetricRangeType.Upper}>
        <ArrowUpwardIcon /> {t("common:and_upper_limits_only")}
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default MetricRangeTypeSelect;
